// extracted by mini-css-extract-plugin
export default {"section_loading":"Spinner_section_loading__WkirP","list_item":"Spinner_list_item__t+br8","animate":"Spinner_animate__u2Eko","list_bars":"Spinner_list_bars__2Hgk3"};